export const SHOW_ALERT = 'SHOW_ALERT';

export const showAlertModal = (component, options) => dispatch => {
  dispatch({
    type: SHOW_ALERT, isOpen: true, component, options: { ...DEFAULT_STATE.options, ...options }
  });
};

export const HIDE_ALERT = 'HIDE_ALERT';

export const hideAlertModal = () => dispatch => {
  dispatch({ type: HIDE_ALERT, isOpen: false });
};

const DEFAULT_STATE = {
  isOpen: false,
  component: null,
  options: {
    title: 'Discard changes?',
    onClose: () => {},
    onClick: () => {}
  },
  props: {}
};

const alertModalReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SHOW_ALERT:
      return { ...state, ...action };
    case HIDE_ALERT:
      return { ...DEFAULT_STATE };
    default:
      return state;
  }
};

export default alertModalReducer;

export const selectAlertModalOpen = state => state.alert.isOpen;
export const selectAlertModalOptions = state => state.alert.options;
export const selectAlertModalComponent = state => state.alert.component;
export const selectAlertModalProps = state => state.alert.props;
